import { useNetwork } from '@nftx/react';
import useInfrastructure from '../../useInfrastructure';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';
import { BadRequestError } from 'nftx.js';

const useSnapshots = (poolIds: string[] | undefined) => {
  const network = useNetwork();
  const {
    pools: { fetchSnapshots },
  } = useInfrastructure();
  const enabled = !!poolIds?.length;

  return useQuery(
    [QueryKey.SNAPSHOTS, network, `${poolIds}`],
    () => {
      if (!poolIds?.length) {
        throw new BadRequestError('poolId is required');
      }
      return fetchSnapshots({ network, poolIds });
    },
    { enabled }
  );
};

export default useSnapshots;
